module.exports = __webpack_public_path__ + "img/trash-icon.9447021e.svg";